// src/App.js
import React from 'react';
import FileUploadForm from './FileUploadForm';

function App() {
  return (
    <div className="App">
      <FileUploadForm />
    </div>
  );
}

export default App;
